import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  assertViewerLens2aypbnpatof3k as assertViewerLens,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
} from '../../../../screens/common/ProjectView.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../../../utils/Draft.ext.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
  reversed22y3au42jl32b as reversed,
  contains2gm06f5aa19ov as contains,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ScopeView2pjeasrtqdymw as ScopeView } from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../nav/crowpay.mjs';
import {
  Subscopelwws6cwdmjzk as Subscope,
  CreateScopeViewDialog2bw9ryrzjhk1t as CreateScopeViewDialog,
} from '../../../../dialogs/NewScopeViewDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Draft3jz09icer2h2u as Draft } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { EditScopeViewDialog24e1qiqowum8p as EditScopeViewDialog } from '../../../../dialogs/EditScopeViewDialog.mjs';
import {
  deleteScopeConfirmation1ansau13nxp5t as deleteScopeConfirmation,
  scopeSetActionsy67y5wxparae as scopeSetActions,
  scopeViewRetryWarningBanner2txar3lw1tei9 as scopeViewRetryWarningBanner,
} from './renderScopeView.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  reorderts8zja415q79 as reorder,
  forEachMaybeReorderable1aeoqjpfy2fje as forEachMaybeReorderable,
} from '../../../reordering.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  get_pending3bzoyvzwzq8kn as get_pending,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_darkSection25mxxvxk8ts3b as get_darkSection,
  get_lightSection4cpu8okr0w14 as get_lightSection,
} from '../../../../theming/sections.mjs';
import { mobileButtonRow232s2tjlco685 as mobileButtonRow } from '../../../../../utils/ButtonAction.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  body3i5t0n7zprpqb as body,
  title1ahgushtajx2d as title,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  labeledSection16775qn7m7foh as labeledSection,
  label287uhiq3m9m4z as label2,
} from '../../../label2.mjs';
import {
  keyMoneyoelmapxkkp81 as keyMoney,
  keyString2ezqnhf3jck9c as keyString,
} from '../../../keyValue.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  renderPriceChangegxsbuhvani39 as renderPriceChange,
  priceWithChangedayxt0y21soj as priceWithChange,
} from '../../../priceChanges.mjs';
import {
  percentComplete22ixcedvdan2 as percentComplete,
  renderPercent3ullukkakwyrl as renderPercent,
  resize3py5p2yrjp6p7 as resize,
  DragShadowu6jlihuvhlhp as DragShadow,
  lensFilter5xvs6ea8thrl as lensFilter,
} from '../../../../../utils/utils.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  timesx4ey3un7ihw1 as times,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
  get_dragHandlemufcu3tsewag as get_dragHandle,
} from '../../../../../icons.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { lineItemCard17zaiwgczjtrr as lineItemCard } from './cards.mjs';
import { GroupedInformationSemantic_getInstance10la8ntbgzaf6 as GroupedInformationSemantic_getInstance } from '../../../../theming/appTheme.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  HalfGap_getInstance2pfkgmm8af0gl as HalfGap_getInstance,
  Movepj4bxmsunu5w as Move,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/forEachReorderable.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0 } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Data3qblafqxenieu as Data } from '../../../../screens/common/AuthorizedProjectView.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { plus18eogev54fmsa as plus_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_scrolling27q1yr4ng0cx8 as get_scrolling } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  scopeSetIcon1d64me82i5zfn as scopeSetIcon,
  timerRunningIcon3mra8cwh7awq2 as timerRunningIcon,
} from '../../../iconShortcuts.mjs';
import { displayState3v4rl6ol8mfdu as displayState } from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic } from '../../../../theming/states.mjs';
import { lineItemBanners14ilhfznw9y75 as lineItemBanners } from './lineItemDetails.mjs';
import { InnerTabBar_getInstance20l55y0u7bopn as InnerTabBar_getInstance } from '../../../../theming/tabs.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  get_requiredMembershipRole1cjo4vwylx1kv as get_requiredMembershipRole,
  get_finishRegistrationMessage1yrf9ce4f09f0 as get_finishRegistrationMessage,
  get_awaitingApprovalMessage2f85iqlczrbum as get_awaitingApprovalMessage,
  renderFinishRegistrationc1cqjl7so0e8 as renderFinishRegistration,
  renderAwaitingApproval2nft16oqsuwts as renderAwaitingApproval,
  render2ibcvtmr1nr93 as render,
  MightBeContractorPage1c5hm6d3mwsqz as MightBeContractorPage,
} from '../../../../screens/contractor/IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Section_Info_instance;
var Section_Items_instance;
function values() {
  return [Section_Info_getInstance(), Section_Items_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Section_entriesInitialized;
function Section_initEntries() {
  if (Section_entriesInitialized)
    return Unit_instance;
  Section_entriesInitialized = true;
  Section_Info_instance = Section().ohv('Info', 0, 'Info');
  Section_Items_instance = Section().ohv('Items', 1, 'Items');
}
var $ENTRIES;
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = assertViewerLens($this.phv_1, $this.phv_1.of3_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, draft, selected, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = modify(draft, ScopeViewDetails$infoSection$slambda$slambda$slambda_0($this.qhv_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = pushChanges(draft, session.ufv_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var scope = tmp_1;
  var tmp_2 = session.tfw().vfg_1.zfq(scope.k7z_1, selected, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var selected_0 = toSet(selected);
  var tmp_3 = (it) => selected_0.t1(it.g6k_1);
  session.mfv_1.ceo(tmp_3, (it) => it.i6l(VOID, VOID, VOID, scope.k7z_1));
  return Unit_instance;
}
var ScopeViewDetails$infoSection$slambda$slambda$slambdaClass;
function ScopeViewDetails$infoSection$slambda$slambda$slambda() {
  if (ScopeViewDetails$infoSection$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rhv_1 = this$0;
      }
      nhp(it, $completion) {
        return it.e80(VOID, VOID, VOID, this.rhv_1.nf3_1);
      }
      s2(p1, $completion) {
        return this.nhp(p1 instanceof ScopeView() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeViewDetails$infoSection$slambda$slambda$slambdaClass = $;
  }
  return ScopeViewDetails$infoSection$slambda$slambda$slambdaClass;
}
function ScopeViewDetails$infoSection$slambda$slambda$slambda_0(this$0) {
  var i = new (ScopeViewDetails$infoSection$slambda$slambda$slambda())(this$0);
  var l = (it, $completion) => i.nhp(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.shv_1.wf3_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.shv_1.pf3_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = new (Subscope())(tmp$ret$1);
  tmp.xgd(new (CreateScopeViewDialog())(tmp_1, tmp_3, ScopeViewDetails$infoSection$slambda$slambda_0($this.shv_1)));
  return Unit_instance;
}
var ScopeViewDetails$infoSection$slambda$slambdaClass;
function ScopeViewDetails$infoSection$slambda$slambda() {
  if (ScopeViewDetails$infoSection$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.qhv_1 = this$0;
      }
      shp(draft, selected, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, draft, selected), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Draft()) : false) ? p1 : THROW_CCE();
        return this.shp(tmp, (!(p2 == null) ? isInterface(p2, KtList()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ScopeViewDetails$infoSection$slambda$slambdaClass = $;
  }
  return ScopeViewDetails$infoSection$slambda$slambdaClass;
}
function ScopeViewDetails$infoSection$slambda$slambda_0(this$0) {
  var i = new (ScopeViewDetails$infoSection$slambda$slambda())(this$0);
  var l = (draft, selected, $completion) => i.shp(draft, selected, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.thv_1.pf3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var scope = tmp;
  var tmp_0 = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.thv_1.tgm();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  var tmp0_safe_receiver = scope.q7z_1;
  var tmp_3;
  if (tmp0_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.thv_1.lgy();
    var tmp_4 = await_0(this_2, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    // Inline function 'kotlin.collections.find' call
    var tmp0 = tmp_4;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.k7z_1.equals(tmp0_safe_receiver)) {
          tmp$ret$4 = element;
          break $l$block;
        }
      }
      tmp$ret$4 = null;
    }
    tmp_3 = tmp$ret$4;
  }
  tmp_0.xgd(new (EditScopeViewDialog())(tmp_2, scope, tmp_3));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.vhv_1.pf3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  deleteScopeConfirmation($this.uhv_1, tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, move, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.whv_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.hf9_1;
    destination.v(tmp$ret$1);
  }
  var tmp_0 = destination;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$4 = tmp_1;
  var tmp_2 = reorder(move, tmp_0, tmp$ret$4.mfv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, move, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xhv_1.tf3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = reorder(move, tmp_0, tmp$ret$1.ufv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.yhv_1.wf3_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.zhv_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = plus(tmp_1, tmp$ret$1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.ahw_1;
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.yhv_1.pf3_1;
  var tmp_6 = await_0(this_3, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp$ret$3 = tmp_6;
  tmp.xgd(new (EditScopeViewDialog())(tmp_3, tmp_5, tmp$ret$3));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.chw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  deleteScopeConfirmation($this.bhw_1, tmp$ret$0);
  return Unit_instance;
}
var SectionClass;
function Section() {
  if (SectionClass === VOID) {
    class $ extends Enum() {
      static ohv(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.nhv_1 = displayName;
        return $this;
      }
      g90() {
        return this.nhv_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Section', VOID, VOID, [HasDisplayName(), Enum()]);
    SectionClass = $;
  }
  return SectionClass;
}
function actionBar($this, _this__u8e3s4) {
  var actions = scopeSetActions($this, _this__u8e3s4, $this.of3_1, $this.pf3_1, $this.vf3_1);
  return _this__u8e3s4.jbb(_this__u8e3s4.ibb(shownWhen(_this__u8e3s4, false, ($this$shownWhen) => {
    var tmp;
    if ($this$shownWhen.baj($this.qf3_1)) {
      var tmp0 = actions;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!($this$shownWhen.baj(element) == null)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    return tmp;
  }), get_darkSection(_this__u8e3s4)), mobileButtonRow(_this__u8e3s4, reversed(actions)));
}
function infoSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().zg1_1);
  var tmp = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.text.isNullOrBlank' call
    var this_0 = $this$shownWhen.baj($this.pf3_1).n7z_1;
    return !(this_0 == null || isBlank(this_0));
  });
  view.jbb(tmp, labeledSection(view, 'Description', ($this$labeledSection) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$labeledSection.pc());
    var tmp0_elvis_lhs = $this$labeledSection.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
    $this$labeledSection.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_1(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp0_elvis_lhs = $this$reactiveScope.baj($this.pf3_1).n7z_1;
      var tmp$ret$1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      this_0.set(tmp$ret$1);
      return Unit_instance;
    });
    $this$labeledSection.fbb(p, view);
    return Unit_instance;
  }));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_2(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_2(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$8 = 'Work ' + $this$reactiveScope.baj($this.rf3_1) + ' Summary';
    this_0.set(tmp$ret$8);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  var tmp_2 = get_lightSection(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(true);
  keyMoney(view_2, 'Original Price', ($this$keyMoney) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$keyMoney.baj($this.vf3_1);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$15 = element.hf9_1.n6k_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$15);
    }
    var tmp$ret$16 = sum;
    return new (MonetaryValue())(tmp$ret$16);
  });
  // Inline function 'com.crowpay.views.components.keyView' call
  var key = 'Accepted Changes';
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xbm(false);
  view_3.zb8(get_rem(0.5));
  bodyBold(view_3, key + ':');
  var tmp_3 = get_expanding(view_3);
  var tmp$ret$19 = renderPriceChange(view_3, false, ($this$renderPriceChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$renderPriceChange.baj($this.vf3_1);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$17 = MonetaryValue__minus_impl_jw9qyp(element.v91(), element.hf9_1.n6k_1);
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$17);
    }
    var tmp$ret$18 = sum;
    return new (MonetaryValue())(tmp$ret$18);
  });
  view_3.jbb(tmp_3, tmp$ret$19);
  view_2.fbb(p_3, view_3);
  // Inline function 'com.crowpay.views.components.keyView' call
  var key_0 = 'Active Price';
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  view_4.xbm(false);
  view_4.zb8(get_rem(0.5));
  bodyBold(view_4, key_0 + ':');
  var tmp_4 = get_expanding(view_4);
  var tmp_5 = ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.baj($this.vf3_1);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$25 = element.v91();
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$25);
    }
    var tmp$ret$26 = sum;
    return new (MonetaryValue())(tmp$ret$26);
  };
  var tmp$ret$29 = priceWithChange(view_4, false, tmp_5, ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.baj($this.vf3_1);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$27 = MonetaryValue__minus_impl_jw9qyp(element.v91(), element.hf9_1.n6k_1);
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$27);
    }
    var tmp$ret$28 = sum;
    return new (MonetaryValue())(tmp$ret$28);
  });
  view_4.jbb(tmp_4, tmp$ret$29);
  view_2.fbb(p_4, view_4);
  keyMoney(view_2, 'Paid', ($this$keyMoney) => $this$keyMoney.baj($this.cf4_1));
  keyString(view_2, '% Complete', ($this$keyString) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$keyString.baj($this.vf3_1);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$35 = element.v91();
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$35);
    }
    var price = sum;
    return renderPercent(percentComplete($this$keyString.baj($this.cf4_1).a5s_1, price));
  });
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_2, view_2);
  view.fbb(p_0, view_0);
  if ($this.of3_1.equals(ProjectLens_Contractor_getInstance())) {
    var tmp_6 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.uf3_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_5 = view.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
    view.ebb(p_5, view_5);
    view_5.xbm(false);
    view_5.zb8(get_AppDimensions().ig2_1);
    var tmp_7 = view_5.ibb(get_expanding(view_5), get_secondaryButton(view_5));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Button())(view_5.pc());
    var tmp0_elvis_lhs_6 = view_5.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
    view_5.ebb(p_6, view_6);
    view_6.jbb(get_centered(view_6), body(view_6, '+ Group'));
    onClick(view_6, VOID, VOID, ScopeViewDetails$infoSection$slambda_0($this));
    view_5.fbb(p_6, view_6);
    view_5.jbb(tmp_7, view_6);
    var tmp_8 = view_5.ibb(get_expanding(view_5), get_secondaryButton(view_5));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Button())(view_5.pc());
    var tmp0_elvis_lhs_7 = view_5.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
    view_5.ebb(p_7, view_7);
    var tmp_9 = get_centered(view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (RowOrCol())(view_7.pc());
    var tmp0_elvis_lhs_8 = view_7.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
    view_7.ebb(p_8, view_8);
    view_8.xbm(false);
    view_8.jbb(get_centered(view_8), icon(view_8, resize(get_edit(Companion_getInstance()), get_rem(1.2)), 'edit'));
    view_8.jbb(get_centered(view_8), body(view_8, 'Edit'));
    view_7.fbb(p_8, view_8);
    view_7.jbb(tmp_9, view_8);
    onClick(view_7, 'Edit Scope', VOID, ScopeViewDetails$infoSection$slambda_2($this));
    view_5.fbb(p_7, view_7);
    view_5.jbb(tmp_8, view_7);
    var tmp_10 = view_5.ibb(get_expanding(view_5), get_secondaryButton(view_5));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Button())(view_5.pc());
    var tmp0_elvis_lhs_9 = view_5.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_5 : tmp0_elvis_lhs_9;
    view_5.ebb(p_9, view_9);
    var tmp_11 = get_centered(view_9);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (RowOrCol())(view_9.pc());
    var tmp0_elvis_lhs_10 = view_9.cbb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
    view_9.ebb(p_10, view_10);
    view_10.xbm(false);
    view_10.jbb(get_centered(view_10), icon(view_10, resize(get_trash(Companion_getInstance()), get_rem(1.2)), 'delete'));
    view_10.jbb(get_centered(view_10), body(view_10, 'Remove'));
    view_9.fbb(p_10, view_10);
    view_9.jbb(tmp_11, view_10);
    onClick(view_9, 'Delete Scope', VOID, ScopeViewDetails$infoSection$slambda_4(view_9, $this));
    view_5.fbb(p_9, view_9);
    view_5.jbb(tmp_10, view_9);
    view.fbb(p_5, view_5);
    view.jbb(tmp_6, view_5);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderItems($this, _this__u8e3s4, items, groupId) {
  var tmp = _this__u8e3s4.hbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp_0 = ScopeViewDetails$renderItems$slambda_0(items);
  var tmp_1 = $this.of3_1.equals(ProjectLens_Contractor_getInstance());
  forEachMaybeReorderable(view, items, groupId, tmp_0, tmp_1, VOID, ($this$forEachMaybeReorderable, item, dragData) => $this$forEachMaybeReorderable.jbb(get_lightSection($this$forEachMaybeReorderable), lineItemCard($this, item, $this.of3_1, dragData, $this$forEachMaybeReorderable)));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function itemsSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  renderItems($this, view, $this.wf3_1, 'items');
  var tmp = view.ibb(shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj($this.tf3_1).i1();
  }), view.hbb(GroupedInformationSemantic_getInstance().ybe(GroupedInformationSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var tmp_0 = ScopeViewDetails$itemsSection$slambda_0($this);
  var tmp_1 = $this.of3_1.equals(ProjectLens_Contractor_getInstance());
  forEachMaybeReorderable(view_0, $this.tf3_1, 'subscopes', tmp_0, tmp_1, VOID, ($this$forEachMaybeReorderable, sub, dragData) => {
    var items = remember(VOID, VOID, VOID, ($this$remember) => {
      var id = $this$remember.baj(sub).k7z_1;
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj($this.vf3_1);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (equals(element.nfy(), id)) {
          destination.v(element);
        }
      }
      return destination;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachMaybeReorderable.pc());
    var tmp0_elvis_lhs = $this$forEachMaybeReorderable.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachMaybeReorderable : tmp0_elvis_lhs;
    $this$forEachMaybeReorderable.ebb(p, view);
    view.xbm(true);
    view.jba(view.ob6_1.ybe(HalfGap_getInstance()));
    var tmp = get_compact(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    var $this$row = view_0;
    if (!(dragData == null)) {
      var tmp_0 = get_centered($this$row);
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (IconView())($this$row.pc());
      var tmp0_elvis_lhs_1 = $this$row.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? $this$row : tmp0_elvis_lhs_1;
      $this$row.ebb(p_1, view_1);
      view_1.ebu('drag');
      view_1.qbt(resize(get_dragHandle(Companion_getInstance()), get_rem(1.2)));
      var tmp_1 = KMutableProperty0();
      var tmp_2 = IconView$_get_dragData_$ref_4jg2ny(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('dragData', 0, tmp_1, tmp_2, IconView$_set_dragData_$ref_k36t82(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        var tmp$ret$4 = $this$reactiveScope.baj(dragData).fcy(VOID, VOID, DragShadow($this$row, Align_Start_getInstance()));
        this_0.set(tmp$ret$4);
        return Unit_instance;
      });
      $this$row.fbb(p_1, view_1);
      $this$row.jbb(tmp_0, view_1);
    }
    var tmp_3 = $this$row.ibb(get_centered($this$row), get_expanding($this$row));
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())($this$row.pc());
    var tmp0_elvis_lhs_2 = $this$row.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
    $this$row.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    var tmp_4 = KMutableProperty0();
    var tmp_5 = TextView$_get_content_$ref_4pzcwl_3(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_3(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$9 = $this$reactiveScope.baj(sub).m7z_1;
      this_1.set(tmp$ret$9);
      return Unit_instance;
    });
    $this$row.fbb(p_2, view_2);
    $this$row.jbb(tmp_3, view_2);
    if ($this.of3_1.equals(ProjectLens_Contractor_getInstance())) {
      var tmp_6 = $this$row.ibb($this$row.ibb(shownWhen($this$row, VOID, ($this$shownWhen) => $this$shownWhen.baj($this.uf3_1)), get_centered($this$row)), get_compact($this$row));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (RowOrCol())($this$row.pc());
      var tmp0_elvis_lhs_3 = $this$row.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? $this$row : tmp0_elvis_lhs_3;
      $this$row.ebb(p_3, view_3);
      view_3.xbm(false);
      var tmp_7 = get_centered(view_3);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var tmp$ret$16 = view_3.hbb(ButtonSemantic_getInstance());
      var tmp_8 = view_3.ibb(tmp_7, tmp$ret$16);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Button())(view_3.pc());
      var tmp0_elvis_lhs_4 = view_3.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
      view_3.ebb(p_4, view_4);
      icon(view_4, resize(get_edit(Companion_getInstance()), get_rem_0(1)), 'Edit Scope');
      onClick(view_4, VOID, VOID, ScopeViewDetails$itemsSection$lambda$slambda_0($this, items, sub));
      view_3.fbb(p_4, view_4);
      view_3.jbb(tmp_8, view_4);
      var tmp_9 = view_3.ibb(get_centered(view_3), get_deleteButton(view_3));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Button())(view_3.pc());
      var tmp0_elvis_lhs_5 = view_3.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
      view_3.ebb(p_5, view_5);
      icon(view_5, resize(get_trash(Companion_getInstance()), get_rem_0(1)), 'Remove Scope');
      onClick(view_5, VOID, VOID, ScopeViewDetails$itemsSection$lambda$slambda_2(view_5, sub));
      view_3.fbb(p_5, view_5);
      view_3.jbb(tmp_9, view_5);
      $this$row.fbb(p_3, view_3);
      $this$row.jbb(tmp_6, view_3);
    }
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    var tmp_10 = shownWhen(view, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = $this$shownWhen.baj(sub).n7z_1;
      return !(this_0 == null || isBlank(this_0));
    });
    view.jbb(tmp_10, keyString(view, 'Description', ($this$keyString) => {
      var tmp0_elvis_lhs = $this$keyString.baj(sub).n7z_1;
      return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    }));
    var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(sub.qah());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k7z_1;
    renderItems($this, view, items, 'subscope-' + (tmp1_elvis_lhs == null ? Companion_getInstance_0().m2p() : tmp1_elvis_lhs).toString());
    $this$forEachMaybeReorderable.fbb(p, view);
    return view;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function ScopeViewDetails$scopeSet$lambda(it) {
  return it.p7z_1;
}
function ScopeViewDetails$unit$lambda(it) {
  return it.p7z_1 ? 'Set' : 'View';
}
function ScopeViewDetails$isManager$lambda($this$remember) {
  var tmp0_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp1_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
}
var ScopeViewDetails$renderMainContent$slambdaClass;
function ScopeViewDetails$renderMainContent$slambda() {
  if (ScopeViewDetails$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.phv_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeViewDetails$renderMainContent$slambdaClass = $;
  }
  return ScopeViewDetails$renderMainContent$slambdaClass;
}
function ScopeViewDetails$renderMainContent$slambda_0(this$0) {
  var i = new (ScopeViewDetails$renderMainContent$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var ScopeViewDetails$infoSection$slambdaClass;
function ScopeViewDetails$infoSection$slambda() {
  if (ScopeViewDetails$infoSection$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.shv_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeViewDetails$infoSection$slambdaClass = $;
  }
  return ScopeViewDetails$infoSection$slambdaClass;
}
function ScopeViewDetails$infoSection$slambda_0(this$0) {
  var i = new (ScopeViewDetails$infoSection$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ScopeViewDetails$infoSection$slambdaClass_0;
function ScopeViewDetails$infoSection$slambda_1() {
  if (ScopeViewDetails$infoSection$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.thv_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeViewDetails$infoSection$slambdaClass_0 = $;
  }
  return ScopeViewDetails$infoSection$slambdaClass_0;
}
function ScopeViewDetails$infoSection$slambda_2(this$0) {
  var i = new (ScopeViewDetails$infoSection$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ScopeViewDetails$infoSection$slambdaClass_1;
function ScopeViewDetails$infoSection$slambda_3() {
  if (ScopeViewDetails$infoSection$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.uhv_1 = $$this$button;
        this.vhv_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeViewDetails$infoSection$slambdaClass_1 = $;
  }
  return ScopeViewDetails$infoSection$slambdaClass_1;
}
function ScopeViewDetails$infoSection$slambda_4($$this$button, this$0) {
  var i = new (ScopeViewDetails$infoSection$slambda_3())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ScopeViewDetails$renderItems$slambdaClass;
function ScopeViewDetails$renderItems$slambda() {
  if (ScopeViewDetails$renderItems$slambdaClass === VOID) {
    class $ {
      constructor($items) {
        this.whv_1 = $items;
      }
      dhm(move, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, move), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeViewDetails$renderItems$slambdaClass = $;
  }
  return ScopeViewDetails$renderItems$slambdaClass;
}
function ScopeViewDetails$renderItems$slambda_0($items) {
  var i = new (ScopeViewDetails$renderItems$slambda())($items);
  var l = (move, $completion) => i.dhm(move, $completion);
  l.$arity = 1;
  return l;
}
var ScopeViewDetails$itemsSection$slambdaClass;
function ScopeViewDetails$itemsSection$slambda() {
  if (ScopeViewDetails$itemsSection$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.xhv_1 = this$0;
      }
      dhm(move, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, move), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeViewDetails$itemsSection$slambdaClass = $;
  }
  return ScopeViewDetails$itemsSection$slambdaClass;
}
function ScopeViewDetails$itemsSection$slambda_0(this$0) {
  var i = new (ScopeViewDetails$itemsSection$slambda())(this$0);
  var l = (move, $completion) => i.dhm(move, $completion);
  l.$arity = 1;
  return l;
}
function IconView$_get_dragData_$ref_4jg2ny(p0) {
  return () => p0.hb9();
}
function IconView$_set_dragData_$ref_k36t82(p0) {
  return (_this__u8e3s4) => {
    p0.gb9(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var ScopeViewDetails$itemsSection$lambda$slambdaClass;
function ScopeViewDetails$itemsSection$lambda$slambda() {
  if (ScopeViewDetails$itemsSection$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $items, $sub) {
        this.yhv_1 = this$0;
        this.zhv_1 = $items;
        this.ahw_1 = $sub;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeViewDetails$itemsSection$lambda$slambdaClass = $;
  }
  return ScopeViewDetails$itemsSection$lambda$slambdaClass;
}
function ScopeViewDetails$itemsSection$lambda$slambda_0(this$0, $items, $sub) {
  var i = new (ScopeViewDetails$itemsSection$lambda$slambda())(this$0, $items, $sub);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ScopeViewDetails$itemsSection$lambda$slambdaClass_0;
function ScopeViewDetails$itemsSection$lambda$slambda_1() {
  if (ScopeViewDetails$itemsSection$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $sub) {
        this.bhw_1 = $$this$button;
        this.chw_1 = $sub;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeViewDetails$itemsSection$lambda$slambdaClass_0 = $;
  }
  return ScopeViewDetails$itemsSection$lambda$slambdaClass_0;
}
function ScopeViewDetails$itemsSection$lambda$slambda_2($$this$button, $sub) {
  var i = new (ScopeViewDetails$itemsSection$lambda$slambda_1())($$this$button, $sub);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Section_Info_getInstance() {
  Section_initEntries();
  return Section_Info_instance;
}
function Section_Items_getInstance() {
  Section_initEntries();
  return Section_Items_instance;
}
var ScopeViewDetailsClass;
function ScopeViewDetails() {
  if (ScopeViewDetailsClass === VOID) {
    class $ {
      constructor(projectId, scopeId, lens_0, parent) {
        parent = parent === VOID ? null : parent;
        var tmp = this;
        tmp.lf3_1 = parent == null ? new (Data())(lens_0, projectId) : parent;
        this.mf3_1 = projectId;
        this.nf3_1 = scopeId;
        this.of3_1 = lens_0;
        var tmp_0 = this;
        var tmp_1 = this.lgy();
        tmp_0.pf3_1 = lens(tmp_1, (it) => {
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = it.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.k7z_1.equals(this.nf3_1)) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().nfx(getKClass(ScopeView()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_2 = this;
        tmp_2.qf3_1 = lens(this.pf3_1, ScopeViewDetails$scopeSet$lambda);
        var tmp_3 = this;
        tmp_3.rf3_1 = lens(this.pf3_1, ScopeViewDetails$unit$lambda);
        var tmp_4 = this;
        tmp_4.sf3_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(this.pf3_1).m7z_1);
        var tmp_5 = this;
        var tmp_6 = this.lgy();
        tmp_5.tf3_1 = lensFilter(tmp_6, (it) => equals(it.q7z_1, this.nf3_1));
        var tmp_7 = this;
        tmp_7.uf3_1 = remember(VOID, VOID, VOID, ScopeViewDetails$isManager$lambda);
        var tmp_8 = this;
        tmp_8.vf3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.baj(this.tf3_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$3 = item.k7z_1;
            destination.v(tmp$ret$3);
          }
          var ids = plus_0(toSet(destination), this.nf3_1);
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.tgm());
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = tmp0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element = _iterator__ex2g4s_0.o1();
            if (contains(ids, element.nfy())) {
              destination_0.v(element);
            }
          }
          return destination_0;
        });
        var tmp_9 = this;
        tmp_9.wf3_1 = lensFilter(this.vf3_1, (it) => equals(it.nfy(), this.nf3_1));
        var tmp_10 = this;
        tmp_10.xf3_1 = get_waitForNotNull(remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.baj(this.vf3_1);
          var tmp$ret$9;
          $l$block_1: {
            // Inline function 'kotlin.collections.minByOrNull' call
            var iterator = tmp0.m1();
            if (!iterator.n1()) {
              tmp$ret$9 = null;
              break $l$block_1;
            }
            var minElem = iterator.o1();
            if (!iterator.n1()) {
              tmp$ret$9 = minElem;
              break $l$block_1;
            }
            var minValue = minElem.kfy();
            do {
              var e = iterator.o1();
              var v = e.kfy();
              if (compareTo(minValue, v) > 0) {
                minElem = e;
                minValue = v;
              }
            }
             while (iterator.n1());
            tmp$ret$9 = minElem;
          }
          return tmp$ret$9;
        }));
        var tmp_11 = this;
        tmp_11.yf3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if ($this$remember.baj(this.qf3_1)) {
            var tmp0 = $this$remember.baj(this.vf3_1);
            var tmp$ret$12;
            $l$block_2: {
              // Inline function 'kotlin.collections.minOfOrNull' call
              var iterator = tmp0.m1();
              if (!iterator.n1()) {
                tmp$ret$12 = null;
                break $l$block_2;
              }
              var minValue = iterator.o1().kfy();
              while (iterator.n1()) {
                var v = iterator.o1().kfy();
                if (compareTo(minValue, v) > 0) {
                  minValue = v;
                }
              }
              tmp$ret$12 = minValue;
            }
            tmp = tmp$ret$12;
          } else {
            tmp = null;
          }
          return tmp;
        });
        var tmp_12 = this;
        tmp_12.zf3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.baj(this.vf3_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$15 = item.kf9_1;
            destination.v(tmp$ret$15);
          }
          var ids = destination;
          var tmp0 = $this$remember.baj(this.hgt());
          var tmp$ret$18;
          $l$block_4: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$18 = false;
              break $l$block_4;
            }
            var _iterator__ex2g4s_0 = tmp0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (element.b6w_1 && ids.t1(element.s6v_1)) {
                tmp$ret$18 = true;
                break $l$block_4;
              }
            }
            tmp$ret$18 = false;
          }
          return tmp$ret$18;
        });
        var tmp_13 = this;
        tmp_13.af4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.vgv());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!(element.v57_1 == null)) {
              destination.v(element);
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            var tmp$ret$23 = item.q57_1;
            destination_0.v(tmp$ret$23);
          }
          return destination_0;
        });
        var tmp_14 = this;
        tmp_14.bf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.baj(this.vf3_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$26 = item.kf9_1;
            destination.v(tmp$ret$26);
          }
          var ids = destination;
          var published = $this$remember.baj(this.af4_1);
          var tmp0 = $this$remember.baj(this.igt());
          var tmp$ret$29;
          $l$block_6: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$29 = false;
              break $l$block_6;
            }
            var _iterator__ex2g4s_0 = tmp0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (get_pending(element) && ids.t1(element.f72_1) && published.t1(element.e72_1)) {
                tmp$ret$29 = true;
                break $l$block_6;
              }
            }
            tmp$ret$29 = false;
          }
          return tmp$ret$29;
        });
        var tmp_15 = this;
        tmp_15.cf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var lines = $this$remember.baj(this.vf3_1);
          var draws = $this$remember.baj(this.hgt());
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = lines.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = sum;
            var tmp_0;
            if (!(element.mfy() == null)) {
              tmp_0 = element.v91();
            } else {
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination = ArrayList().w();
              var _iterator__ex2g4s_0 = draws.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element_0 = _iterator__ex2g4s_0.o1();
                if (element_0.s6v_1.equals(element.kf9_1) && (element_0.b6w_1 || element_0.z6v_1 === true)) {
                  destination.v(element_0);
                }
              }
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum_0 = Companion_instance.p91(0n);
              var _iterator__ex2g4s_1 = destination.m1();
              while (_iterator__ex2g4s_1.n1()) {
                var element_1 = _iterator__ex2g4s_1.o1();
                var tmp_1 = sum_0;
                var tmp$ret$34 = element_1.t6v_1;
                sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$34);
              }
              tmp_0 = sum_0;
            }
            var tmp$ret$36 = tmp_0;
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$36);
          }
          var tmp$ret$37 = sum;
          return new (MonetaryValue())(tmp$ret$37);
        });
        this.df4_1 = Signal().fak(Section_Items_getInstance());
      }
      jf8() {
        return this.mf3_1;
      }
      rgj() {
        return this.of3_1;
      }
      ucv() {
        return this.sf3_1;
      }
      shf(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        launch(view, VOID, VOID, ScopeViewDetails$renderMainContent$slambda_0(this));
        var tmp = view.ibb(get_expanding(view), get_scrolling(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        view_0.zb8(get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_rem(0.5));
        var tmp_0 = get_lightSection(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        var tmp_1 = get_compact(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        var tmp_2 = get_centered(view_3);
        view_3.jbb(view_3.ibb(tmp_2, shownWhen(view_3, VOID, ($this$shownWhen) => $this$shownWhen.baj(this.qf3_1))), scopeSetIcon(view_3, times(get_AppDimensions().sg1_1, 1.1)));
        var tmp_3 = get_centered(view_3);
        view_3.jbb(tmp_3, title(view_3, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.baj(this.pf3_1).m7z_1;
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          return Unit_instance;
        }));
        view_2.fbb(p_3, view_3);
        view_2.jbb(tmp_1, view_3);
        var tmp_4 = shownWhen(view_2, VOID, ($this$shownWhen) => !($this$shownWhen.baj(this.yf3_1) == null));
        view_2.jbb(tmp_4, label2(view_2, 'Status', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.xbm(false);
          title(view, ($this$title) => {
            dynamicTheme($this$title, ($this$dynamicTheme) => {
              var tmp0_safe_receiver = $this$dynamicTheme.baj(this.yf3_1);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : displayState(tmp0_safe_receiver);
              var tmp;
              if (tmp1_safe_receiver == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                tmp = LineItemStateSemantic(tmp1_safe_receiver);
              }
              return tmp;
            });
            var tmp = KMutableProperty0();
            var tmp_0 = TextView$_get_content_$ref_4pzcwl_0($this$title);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0($this$title));
            reactiveScope($this$title, ($this$reactiveScope) => {
              var tmp0_safe_receiver = $this$reactiveScope.baj(this.yf3_1);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : displayState(tmp0_safe_receiver);
              var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j9b_1;
              var tmp$ret$8 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
              this_0.set(tmp$ret$8);
              return Unit_instance;
            });
            return Unit_instance;
          });
          view.jbb(get_centered(view), timerRunningIcon(this, view, this.xf3_1));
          $this$label2.fbb(p, view);
          return view;
        }));
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_0, view_2);
        view_0.fbb(p_1, view_1);
        var tmp_5 = this.jfy();
        lineItemBanners(this, view_0, this.xf3_1, tmp_5, remember(VOID, VOID, VOID, ($this$remember) => {
          var e = $this$remember.baj(this.xf3_1).kf9_1;
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.bgt());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.a6h_1.equals(e)) {
              destination.v(element);
            }
          }
          return destination;
        }), this.zf3_1, this.bf4_1, this.of3_1, this.pf3_1);
        scopeViewRetryWarningBanner(view_0, this.pf3_1, this.vf3_1, this.of3_1);
        var tmp_6 = view_0.hbb(InnerTabBar_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.ebb(p_4, view_4);
        view_4.xbm(false);
        var _iterator__ex2g4s = get_entries().m1();
        while (_iterator__ex2g4s.n1()) {
          var section = _iterator__ex2g4s.o1();
          var tmp_7 = get_expanding(view_4);
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var tmp$ret$25 = view_4.hbb(ButtonSemantic_getInstance());
          var tmp_8 = view_4.ibb(tmp_7, tmp$ret$25);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RadioToggleButton())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.ebb(p_5, view_5);
          view_5.jbb(get_centered(view_5), body(view_5, section.nhv_1));
          view_5.xah(view_5.zc8_1, equalTo(this.df4_1, section));
          view_4.fbb(p_5, view_5);
          view_4.jbb(tmp_8, view_5);
        }
        view_0.fbb(p_4, view_4);
        view_0.jbb(tmp_6, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_6 = view_0.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
        view_0.ebb(p_6, view_6);
        var $this$frame = view_6;
        reactive($this$frame, ($this$reactive) => {
          $this$frame.zb9();
          var tmp;
          switch ($this$reactive.baj(this.df4_1).b4_1) {
            case 0:
              tmp = infoSection(this, $this$frame);
              break;
            case 1:
              tmp = itemsSection(this, $this$frame);
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          return tmp;
        });
        view_0.fbb(p_6, view_6);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        actionBar(this, view);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      jfy() {
        return this.lf3_1.jfy();
      }
      tgm() {
        return this.lf3_1.tgm();
      }
      xgz() {
        return this.lf3_1.xgz();
      }
      wgk() {
        return this.lf3_1.wgk();
      }
      fgl() {
        return this.lf3_1.fgl();
      }
      ugm() {
        return this.lf3_1.ugm();
      }
      vgv() {
        return this.lf3_1.vgv();
      }
      lgy() {
        return this.lf3_1.lgy();
      }
      igt() {
        return this.lf3_1.igt();
      }
      jgt() {
        return this.lf3_1.jgt();
      }
      hgt() {
        return this.lf3_1.hgt();
      }
      bgt() {
        return this.lf3_1.bgt();
      }
      egt() {
        return this.lf3_1.egt();
      }
      ngf() {
        return this.lf3_1.ngf();
      }
      oh2() {
        return this.lf3_1.oh2();
      }
      mgf() {
        return this.lf3_1.mgf();
      }
      sh2() {
        return this.lf3_1.sh2();
      }
    }
    protoOf($).bhg = get_requiredMembershipRole;
    protoOf($).chg = get_finishRegistrationMessage;
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'ScopeViewDetails', VOID, VOID, [MightBeContractorPage()]);
    ScopeViewDetailsClass = $;
  }
  return ScopeViewDetailsClass;
}
//region block: exports
export {
  ScopeViewDetails as ScopeViewDetailsf9xt7m1tnie,
};
//endregion

//# sourceMappingURL=ScopeViewDetails.mjs.map
